import { Component } from '@angular/core';
import { AnnouncementService } from 'src/app/services/announcement.service';
import { SpotService } from 'src/app/services/spot.service';
import { UserService } from 'src/app/services/user.service';
import { WalletService } from 'src/app/services/wallet.service';
import { UserFacade } from 'src/app/store/user';
import { UserSettingFacade } from 'src/app/store/usersetting';
import { environment } from 'src/environments/environment';

interface QueryParams {
    fillter: string,
    sortObj: string,
    page: number,
    limit: number
}
@Component({
  selector: 'app-task-center',
  templateUrl: './task-center.component.html',
  styleUrls: ['./task-center.component.css']
})
export class TaskCenterComponent {
user:any;

  filter: any = {
    page: 1,
    limit: 10,
    totalPages: 0,
    coin: "all",
    paymentType: "all",
    payment: "all",
    status: 
    "all"
  }
    filter2 = {
    page: 1,
    limit: 10,
    totalPages: 0,
    pairName: "all",
    orderType: "all",
    buyorsell: "all",
    status: "all"
  }
    pageSize = 10;
  currentPage = 0;
    queryParams: QueryParams = {
    fillter: '{}',
    sortObj: '{}',
    page: this.currentPage + 1,
    limit: this.pageSize
  };
  imageUrls: string[] = [];
  txnHistory: any;
  tradeHistory: any;
  userId: any;
  refer: any;
  constructor(private userFacade:UserFacade,
    private service :WalletService,
    private spotService:SpotService,
    private userService:UserService,
    private announcementService :AnnouncementService

) {}

  ngOnInit() {
    // Simulating backend API response
    this.fetchImages();
        this.userFacade.user$.subscribe({
      next: (user) => {
        this.user = user,
        this.userId=user.userId
            this.referFriends();

      },
      error: () => { }
    }) 
    this.fetchTxnHistory(this.filter);
    this.fetchtradeHistory(this.filter2);
  }

  fetchImages(): void {
    this.announcementService.getAllOffers(this.queryParams).subscribe({
      next: (res: any) => {
        const baseUrl = environment.userApiUrl + '/slider/';
        this.imageUrls = res.result?.data
          .filter((img: any) => img.status === 'active' && img.modelName === 'task-center')
          .map((img: any) => baseUrl + img.image);
      },
      error: () => {
        this.imageUrls = [];
      }
    });
  }

    referFriends() {
      this.userService.findReferData(this.userId).subscribe({
        next: (data: any) => {
          this.refer = data.status;
          console.log(this.refer,'refer')
        },
        error: () => { }
      })
    }

    fetchTxnHistory(filter: any) {
      this.service.gettxnhistory(filter).subscribe({
        next: (data: any) => {
          this.txnHistory = data.result?.count;
          console.log(this.txnHistory,'txnHistory')
        },
        error: () => { }
      })
    }
     fetchtradeHistory(filter2: any) {
        this.spotService.gethistorytradeHistory(filter2).subscribe({
          next: (data: any) => {
            this.tradeHistory = data.result?.count
                   console.log(this.tradeHistory,'tradeHistory')
          },
          error: () => { }
        })
      }



}
